import photo from "./photo.jpg";
import Group240 from "./Group 240.png";
import Group421 from "./Group 421.png";
import Group491 from "./Group 491.png";
import Img1 from "./img1.PNG";
import Img2 from "./img2.PNG";
import Img3 from "./img3.PNG";
import Img4 from "./img4.PNG";
import Img5 from "./img5.PNG";
import Img6 from "./img6.PNG";
import Img7 from "./img7.PNG";
import Img8 from "./img8.PNG";
import Img9 from "./img9.PNG";
import Img10 from "./img10.PNG";
import Img11 from "./img11.PNG";
import Img12 from "./img12.PNG";
import Img13 from "./img13.PNG";
import Img14 from "./img14.PNG";
import Img15 from "./img15.PNG";
import Img16 from "./img16.PNG";
import Img17 from "./img17.PNG";
import Img18 from "./img18.PNG";
import Img19 from "./img19.PNG";
import Img20 from "./img20.PNG";
import Img22 from "./img22.PNG";
import Img23 from "./img23.PNG";
import Img24 from "./img24.PNG";
import Img25 from "./img25.PNG";
import Img44 from "./img44.PNG";
import Img88 from "./img88.PNG";
const Images = {
  photo: photo,
  Group240: Group240,
  Group421: Group421,
  Group491: Group491,
  Img1: Img1,
  Img2: Img2,
  Img3: Img3,
  Img4: Img4,
  Img5: Img5,
  Img6: Img6,
  Img7: Img7,
  Img8: Img8,
  Img9: Img9,
  Img10: Img10,
  Img11: Img11,
  Img12: Img12,
  Img13: Img13,
  Img14: Img14,
  Img15: Img15,
  Img16: Img16,
  Img17: Img17,
  Img18: Img18,
  Img19: Img19,
  Img20: Img20,
  Img22: Img22,
  Img23: Img23,
  Img24: Img24,
  Img25: Img25,
  Img44: Img44,
  Img88: Img88,
};
export default Images;
